import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { ToasterService } from './services/toaster.service'

export const HttpInterceptor: HttpInterceptorFn = (req, next) => {
  const _toasterService = inject(ToasterService)
  return next(req).pipe(
    catchError((error) => {
      let errorMessage = 'UNKNOWN ERROR'
      if (error.message) {
        errorMessage = error.message
      }
      switch (error.status) {
        case 0:
          if (!navigator.onLine) {
            errorMessage = 'No internet'
            break
          }
          break
        default:
          // Error defined by backender, see files errors.py and restplus.py
          if (error.error instanceof Blob) {
            error.error.text().then((text: string) => {
              try {
                errorMessage = JSON.parse(text)?.message ?? errorMessage
              } catch {}
              _toasterService.openSnackBarError(errorMessage.substring(0, 200))
            })
            return throwError(() => error)
          }
          if (error.error.message) {
            errorMessage = error.error.message
          }
      }
      console.warn(`Error ${error.status} occurs`, errorMessage)
      if (errorMessage.length > 50) {
        errorMessage = errorMessage.substring(0, 200) + '...'
      }
      _toasterService.openSnackBarError(errorMessage)

      return throwError(() => error)
    }),
  )
}
